/*
 * Makes the Klarna on-site messaging placement use the theme font.
 *
 * <klarna-placement> renders into an open shadow DOM whose internal stylesheet
 * pins the type:
 *
 *   .container { font-family: -apple-system, BlinkMacSystemFont, ... }
 *   .link      { font-family: -apple-system, BlinkMacSystemFont, ... }
 *   .logo      { font-family: "Klarna Headline"; font-weight: bold; }
 *
 * Because those rules live inside the shadow tree, external CSS cannot reach
 * them and font-family does not inherit through the host. Appending a <style>
 * into the shadow root does work, so that is what this does.
 *
 * `.logo` is deliberately left alone — that is Klarna's wordmark and should
 * keep its brand typeface. Only the surrounding descriptive text changes, and
 * the wording is never touched.
 *
 * These are Klarna's internal class names. If they change, this quietly stops
 * applying and the placement keeps its own styling.
 */
(function () {
  var HOST = 'klarna-placement';
  var STYLE_ID = 'theme-font-override';
  var POLL_MS = 250;
  var MAX_TRIES = 40;

  var CSS = [
    '.container, .link, p, span {',
    '  font-family: inherit;',
    '}',
    /* Keep Klarna's wordmark in its own brand face. */
    '.logo {',
    '  font-family: "Klarna Headline" !important;',
    '}'
  ].join('\n');

  function apply(shadowRoot) {
    if (shadowRoot.getElementById(STYLE_ID)) return true;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    shadowRoot.appendChild(style);
    return true;
  }

  function attach(el) {
    if (!el.shadowRoot) return false;
    apply(el.shadowRoot);

    // The placement re-renders on variant/price changes, which can replace the
    // shadow contents. Re-append if our style element goes missing.
    new MutationObserver(function () {
      apply(el.shadowRoot);
    }).observe(el.shadowRoot, { childList: true, subtree: true });

    return true;
  }

  function init() {
    document.querySelectorAll(HOST).forEach(function (el) {
      if (attach(el)) return;

      var tries = 0;
      var timer = setInterval(function () {
        if (attach(el) || ++tries > MAX_TRIES) clearInterval(timer);
      }, POLL_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
